import { render, staticRenderFns } from "./FileSystem.vue?vue&type=template&id=2c800c17&scoped=true"
import script from "./FileSystem.vue?vue&type=script&lang=js"
export * from "./FileSystem.vue?vue&type=script&lang=js"
import style0 from "./FileSystem.vue?vue&type=style&index=0&id=2c800c17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c800c17",
  null
  
)

export default component.exports